module.exports = __webpack_public_path__ + "img/question.70f18f18.png";